import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="step-form"
export default class extends Controller {
    static targets = ['buttonContainer', 'dayIndexStart', 'dayIndexEnd', "eventTimes", "dayStart", "dayEnd", "step", "featureFlag", "bleTagsSelect"]
    static values = {
        dayId: { type: Number, default: 0}
    }

    connect() {
        if(this.element.dataset.startPoint) history.replaceState({}, "", this.element.dataset.startPoint)
    }

    addDay(_event) {
        this.buttonContainerTarget.insertAdjacentHTML('beforebegin', this._getEventDay())
        this._updateDayNumber()
    }

    removeDay(event) {
        let parent = event.currentTarget.closest(".step-form-row")
        let group = parent.closest(".step-form-day-group")
        if(group) {
            parent = group
            group.querySelectorAll("[name*='[id]'], [name*='[_destroy]']").forEach(input => {
                input.removeAttribute("form")
                this.element.appendChild(input)
            })
        }
        parent.remove()
        this._updateDayNumber()
    }

    addEventTimes(_event) {
        let eventDaysTime = []
        if(this.hasDayIndexStartTarget) {
            for(let i = 0; i < this.dayIndexStartTargets.length; i += 1 )
                eventDaysTime.push(`${this.dayStartTargets[i].value} - ${this.dayEndTargets[i].value}`)
            if(this.hasEventTimesTarget) this.eventTimesTarget.setAttribute("value", eventDaysTime.join(', ')) 
        }
    }

    addDayWithBlockList(event) {
        this.buttonContainerTarget.insertAdjacentHTML('beforebegin', this._getEventDayWithBleBlocklist({startDate: event.currentTarget.dataset.startDateName, 
                                                                                                        endDate: event.currentTarget.dataset.endDateName}))
        this._updateDayNumber()
        this.dayIdValue++
    }

    changeStep(event, value = event.currentTarget.dataset.step) {
        this.stepTarget.setAttribute("value", value)
    }

    removeRequired() {
        this.element.querySelectorAll("[required]").forEach(input => input.removeAttribute("required"))
    }

    _updateDayNumber() {
        if (this.hasDayIndexStartTarget) this.dayIndexStartTargets.forEach((element, index) => element.innerHTML = `&nbsp;${index + 1}&nbsp;`)
        if (this.hasDayIndexEndTarget) this.dayIndexEndTargets.forEach((element, index) => element.innerHTML = `&nbsp;${index + 1}&nbsp;`)
    }

    toggleFeatureFlag(event) {
        let feature = event.currentTarget.closest(".step-form-row").previousElementSibling
        if(!feature) return
        feature.style.height = event.currentTarget.checked ? event.currentTarget.dataset.height : "0px"
    }

    featureFlagTargetConnected(element) {
        let feature = element.closest(".step-form-row").previousElementSibling
        element.dataset.height = feature.offsetHeight + "px"
        if(!feature) return
        feature.style.height = element.checked ? element.dataset.height : "0px"
    }

    _getEventDay({startDate = "none", endDate = "none", skipSubmission = true} = {}) {
        return `
            <div class="step-form-row" data-controller="tz-dates-field" data-tz-dates-field-tz-dates-field-outlet="[data-controller='tz-dates-field']">
                <div class="step-form-row-item">
                    <label class="step-form-label required">Event Day<span data-step-form-target="dayIndexStart"></span>Start</label>
                    <input class="step-form-input" required="required" type="datetime-local" name="${startDate}" ${skipSubmission ? "form='none'" : ''} data-step-form-target="dayStart" data-tz-dates-field-target="startDate" data-action="change->tz-dates-field#changeEndDate">
                </div>
                <div class="step-form-row-item">
                    <label class="step-form-label">
                        <span class="required">Event Day<span data-step-form-target="dayIndexEnd"></span>End</span>
                        <img src="/assets/icons/delete-grey-4ce796f4.svg" data-action="click->step-form#removeDay">
                    </label>
                    <input class="step-form-input" required="required" type="datetime-local" name="${endDate}" ${skipSubmission ? "form='none'" : ''} data-step-form-target="dayEnd" data-tz-dates-field-target="endDate">
                </div>
            </div>
        `
    }

    _getEventDayWithBleBlocklist({startDate, endDate}) {
        return `<div class="step-form-day-group">
                    ${this._getEventDay({startDate: this._replaceId(startDate), endDate: this._replaceId(endDate), skipSubmission: false}) + `
                            <div class="step-form-row">
                                <div class="step-form-row-item">
                                    <label for="event-day-blocked-ble-tags-${this.dayIdValue}" class="step-form-label">BLE Tags Block List</label>
                                    ${this._getBlocklistedBleTagSelectElement().outerHTML}
                                </div>
                            </div>
                            <hr>
                    `}
                </div>
        `
    }

    _replaceId(fieldName) {
        return fieldName.replace("_id", this.dayIdValue)
    }

    _getBlocklistedBleTagSelectElement() {
        let select = this.bleTagsSelectTarget.cloneNode(true)
        select.classList.remove("hidden")
        select.dataset.controller="form-select"
        select.removeAttribute("data-step-form-target")
        select.setAttribute("id", "event-day-blocked-ble-tags-" + this.dayIdValue)
        select.setAttribute("name", this._replaceId(this.bleTagsSelectTarget.getAttribute("name")))
        return select
    }

    changeUrl() {
        let methodInput = this.element.querySelector("[name*='_method'][value='patch']")
        if(methodInput) {
            this.element.setAttribute("action", this.element.dataset.startPoint)
            this.element.setAttribute("method", "get")
            methodInput.remove()
        }
    }
}
